var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73828 11.3477C10.4023 11.3379 10.9102 11.1035 11.457 10.5664L18.4199 3.41797C18.8105 3.02734 18.9863 2.58789 18.9863 2.03125C18.9863 0.917969 18.0781 0 16.9844 0C16.4277 0 15.9102 0.224609 15.4902 0.664062L9.75781 6.65039L3.99609 0.664062C3.57617 0.234375 3.05859 0 2.49219 0C1.39844 0 0.490234 0.917969 0.490234 2.03125C0.490234 2.57812 0.675781 3.01758 1.05664 3.41797L8.0293 10.5664C8.57617 11.1133 9.09375 11.3477 9.73828 11.3477Z",
    fill: "#003E88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIcon);
export default __webpack_public_path__ + "static/media/down-arrow-icon.e0064974f86c3296261c419b208a7be0.svg";
export { ForwardRef as ReactComponent };